import { showApiErrorToast } from "./showApiErrorToast";

import type { ReportReadyDetail } from "./reportReadyEvents";

const shownReportReadyToasts = new Set<string>();

export function toastReportReadyOnce(
  detail: Pick<ReportReadyDetail, "reportId" | "status" | "message" | "action">,
  opts?: { title?: string; description?: string }
): void {
  const reportId = detail.reportId.trim();
  if (!reportId) return;

  const status = String(detail.status ?? "published").toLowerCase();
  const dedupeKey = `${reportId}:${status === "failed" ? "failed" : "ready"}`;
  if (shownReportReadyToasts.has(dedupeKey)) return;
  shownReportReadyToasts.add(dedupeKey);

  const title = opts?.title?.trim();

  if (status === "failed") {
    const primary = detail.message?.trim() || title || "Report generation failed";
    const secondary =
      detail.action?.trim() ||
      (!detail.message?.trim() ? opts?.description?.trim() : undefined) ||
      (!detail.message?.trim() && !detail.action?.trim()
        ? "Something went wrong while building this report."
        : undefined);
    showApiErrorToast({
      title: primary,
      description: secondary,
      status: "error",
    });
    return;
  }

  showApiErrorToast({
    title: title || "Report ready",
    description: opts?.description?.trim() || detail.message?.trim() || "Your report is now available.",
    status: "success",
  });
}
